import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";

const CloudSolutions = () => {
  useEffect(() => {
    Aos.init({ duration: 1200, once: false });
    //No Aos.destroy() here
  }, []);

  return (
    <section className="min-h-screen py-20 px-6 bg-blue-950">
      <div className="max-w-7xl mx-auto">
        <h2
          className="text-4xl sm:text-5xl font-bold font-poppins text-center text-sky-400 mb-12"
          data-aos="fade-down"
        >
          Cloud Solutions
        </h2>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div data-aos="fade-right" className="space-y-6 text-white font-inter">
            <p className="text-lg leading-relaxed">
              Unlock the power of cloud computing with our scalable and secure cloud
              solutions. Whether you're moving to the cloud or optimizing existing infrastructure,
              we help you leverage AWS, Microsoft Azure Cloud effectively.
            </p>
           <ul className="list-disc pl-5 text-base space-y-2">
              <li>Cloud Infrastructure Setup (AWS, Azure,)</li>
              <li>Cloud Migration Services – Seamless transition from on-premise to cloud</li>
              <li>Hybrid & Multi-Cloud Architecture – Flexible, scalable environments</li>
              <li>Cloud Backup & Disaster Recovery – Secure, automated data protection</li>
              <li>SaaS Integration & Management – Tools like Microsoft 365, Google Workspace</li>
              <li>Cloud Security & Compliance – End-to-end protection of cloud assets</li>
            </ul>
          </div>

          {/* Right Image */}
          <div data-aos="fade-left">
            <img
              src="/servicepages/cloud.jpeg"
              alt="Cloud Services"
              className="w-full h-auto rounded-xl shadow-xl object-contain"
            />
          </div>
        </div>

        {/* Animated Feature Cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-16">
          {[
            {
              title: "Cloud Backup",
              desc: "Secure offsite backups with automated versioning and recovery options.",
              icon: "/servicepages/cloudbackup.png",
            },
            {
              title: "SaaS Deployment",
              desc: "Deploy scalable SaaS platforms for internal or customer-facing apps.",
              icon: "/servicepages/saas.png",
            },
            {
              title: "Hybrid Infrastructure",
              desc: "Blend on-prem and cloud solutions for agility and control.",
              icon: "/servicepages/hybridcloud.jpg",
            },
          ].map((item, i) => (
            <div
              key={i}
              data-aos="zoom-in"
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition"
            >
              <img
                src={item.icon}
                alt={item.title}
                className="h-14 w-14 mb-4 object-cover"
              />
              <h4 className="text-xl font-semibold text-blue-500">{item.title}</h4>
              <p className="text-black  mt-2">{item.desc}</p>
            </div>
          ))}
        </div>
        
        {/* CTA */}
        <div className="text-center mt-20">
          <a
            href="/contact"
            className="inline-block bg-gray-50 text-blue-950 px-8 py-3 rounded-md font-semibold hover:text-sky-400 transition"
          >
            Talk to Our Experts
          </a>
        </div>
      </div>
    </section>
  );
};

export default CloudSolutions;
